const commonProperties = {
  name: {
    type: 'string',
    showInForm: true,
    formFieldType: 'text'
  },
  modifier: {
    label: 'Modifier',
    type: 'string',
    showInForm: true,
    formFieldType: 'text'
  }
};

const newsletterIdString = {
  type: 'string',
  showInForm: true,
  formFieldType: 'text',
  label: 'Abacus newsletter ids to add user to (e.g. 1,5,3)'
};

const salesForceCampaignId = {
  label: 'Custom Salesforce Campaign ID',
  type: ['string', 'null'],
  showInForm: true,
  formFieldType: 'text'
};

const salesforceProducts = {
  label: 'Salesforce products',
  tooltip: 'Enter multiple products separated by commas',
  type: ['string', 'null'],
  showInForm: true,
  formFieldType: 'text'
};

const finePrintOverride = {
  label: 'Fine print override',
  type: 'string',
  showInForm: true,
  formFieldType: 'textarea'
};

const customProperties = {
  label: 'Custom properties',
  type: 'array',
  showInForm: true,
  formFieldType: 'collection',
  labelProperty: 'propertyName',
  items: {
    label: 'Custom property',
    type: 'object',
    showInForm: true,
    formFieldType: 'object',
    properties: {
      propertyName: {
        id: 'propertyName',
        label: 'Property name',
        type: 'string',
        formFieldType: 'text',
        showInForm: true
      },
      propertyValue: {
        id: 'propertyValue',
        label: 'Property value',
        type: 'string',
        formFieldType: 'text',
        showInForm: true
      }
    },
    required: ['propertyName', 'propertyValue']
  }
};

const editorViewProperties = {
  canShowInEditorView: {
    type: 'boolean',
    showInForm: false,
    default: true
  },
  showInEditorView: {
    type: 'boolean',
    showInForm: false,
    default: true
  }
};

const LOGIN = 'login';
const MENU = 'menu';
const MENU_ITEM = 'menuitem';
const SUB_MENU = 'submenu';
const SEARCH_FILTER = 'searchfilter';
const SEARCH_FILTER_SORT = 'searchfiltersort';
const MODAL = 'modal';
const REGISTRATION_FORM = 'registration-form';
const RESTRICTED_USER_UPDATE_FORM = 'restricted-user-update-form';

const colorOptions = [
  ['', 'Default'],
  ['blue', 'Blue'],
  ['orange', 'Orange']
];

const promotionTypeOptions = [
  ['standard', 'Standard'],
  ['featured', 'Featured'],
  ['sponsored', 'Sponsored'],
  ['inherit', 'Inherit']
];

export {
  editorViewProperties,
  commonProperties,
  colorOptions,
  promotionTypeOptions,
  LOGIN,
  MENU,
  MENU_ITEM,
  SUB_MENU,
  SEARCH_FILTER,
  SEARCH_FILTER_SORT,
  MODAL,
  REGISTRATION_FORM,
  RESTRICTED_USER_UPDATE_FORM,
  newsletterIdString,
  salesForceCampaignId,
  salesforceProducts,
  finePrintOverride,
  customProperties
};
